import { useState } from "react";
import { BiX } from "../../../../icons/bi";
import { ICONS } from "../constants/icons";
import { YearDropDown } from "./Year";

const GolbalSearch = (props) => {
  const [globalText, setGlobalText] = useState("");
  const width = props.withYear ? "52%" : "55%";
  const isWCS = props.variant === "wcs";
  if (isWCS) {
    return (
      <div className="float-end m-1 wcs-search-box">
        <div>
          <img src={ICONS.SearchIcon} alt="search" style={{ cursor: "pointer" }} />
          <input
            style={{ width: "270px" }}
            type="text"
            placeholder={props.searchplaceholdertext}
            value={globalText}
            onChange={(e) => {
              setGlobalText(e.target.value);
              props.filterFunc(e.target.value);
            }}
          />
          <BiX
            size={20}
            color="black"
            style={{ cursor: "pointer", color: "var(--col-707070)", float: "right", margin: "6px" }}
            onClick={(e) => {
              setGlobalText("");
              props.filterFunc("");
            }}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="float-end m-1 global-search-box searchmobile">
      {props.withYear ? <YearDropDown onChange={props.YearHandleChange}
        selectedyear={props.YearSelected}> </YearDropDown> : ""}
      &nbsp; &nbsp;
      <div style={{ width: width, borderColor: "var(--col-ddd)" }}>
        <img
          src={ICONS.SearchIcon}
          alt="search"
          style={{ cursor: "pointer" }}
        />
        <input
          type="text"
          placeholder={props.searchplaceholdertext}
          value={globalText}
          onChange={(e) => {
            setGlobalText(e.target.value);
            props.filterFunc(e.target.value);
          }}
        />
        <BiX
          size={20}
          color="black"
          className="xiconsearch"
          style={{ cursor: "pointer", color: "var(--col-707070)", float: "right" }}
          onClick={(e) => {
            setGlobalText("");
            props.filterFunc("");
          }}
        />
      </div>
    </div>
  );
};

export default GolbalSearch;